import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import AdhocProgram from './AdhocProgram';
import { openErrorToast } from '../../../../../../reducers/uiLogic';
import {
  getProgramInfoInitiate,
  reviewProgramInitiate,
} from '../../../../../../actions/programs';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const programInfo = _get(state, 'programs.programInfo', {});
  const { programs = {} } = state;
  const { reviewProgramDetails = {} } = programs;
  const userData = _get(state, 'user', 0);
  const companyProfile = _get(state, 'company', {});
  return {
    userData,
    companyProfile,
    reviewProgramDetails,
    selectedWorkspace,
    reviewingProgram:
      _get(state, 'apiState.REVIEW_PROGRAM.isFetching', false) &&
      !_get(state, 'apiState.REVIEW_PROGRAM.isIdle', true),
    reviewProgramSuccess: _get(state, 'apiState.REVIEW_PROGRAM.success', false),
    programInfo,
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  reviewProgram: payload => dispatch(reviewProgramInitiate(payload)),
  getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdhocProgram);
